type Props = {
    error?: string;
};

/**
 *
 * @deprecated
 *
 * This is only used in legacy code. Feels very redundant and not really worthy of being a component in itself.
 *
 * If legacy code that uses this component is updated. Look removing this component from it.
 */
const InputError = (props: Props) => {
    if (props.error) {
        return <label className="error">{props.error}</label>;
    }
    return null;
};

export default InputError;
